import React from "react";

import {
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
  InputProps,
  FormControlProps,
} from "@mui/material";

export interface TextFieldProps extends Partial<FormControlProps> {
  id?: string;
  name?: string;
  label?: string;
  onEnter?: () => void;
  onEscPress?: () => void;
  InputProps?: InputProps;
  defaultValue?: string;
  error?: boolean;
  helperText?: string | null;
  type?: string;
}

const TextField = ({
  id,
  name,
  onEnter,
  onEscPress,
  type,
  helperText,
  label,
  InputProps,
  margin,
  error,
  defaultValue,
  ...other
}: TextFieldProps) => {
  const inputId = id || `input-${name ?? InputProps?.name}`;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      case "Enter":
        if (onEnter) {
          event.preventDefault();
          onEnter();
        }
        break;
      case "Escape":
        if (onEscPress) {
          event.stopPropagation();
          onEscPress();
        }
        break;
      default:
        break;
    }
  };

  return (
    <FormControl fullWidth margin={margin || "none"} error={error} {...other}>
      {label && <FormLabel htmlFor={inputId}>{label}</FormLabel>}
      <OutlinedInput
        id={inputId}
        name={name}
        type={type || "text"}
        onKeyDown={handleKeyDown}
        defaultValue={defaultValue}
        {...InputProps}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default TextField;
